//import Libraries
import React, { Component } from 'react';
import {connect} from 'react-redux';

//import Components
import {Container, Row, Col, Button} from 'reactstrap'
import ContactPagination from './ContactPagination';

import * as contactActions from './actions/contactActions';

//import Styles
import '../Admin.css'

const contactManager = (props) => {
    return (
        <div className="admin-element">
            <Container>
                <h1>
                    연락 관리
                </h1>
                <hr />
            </Container>

            <Container className="CommandWrapper">
                <Row>
                    <Col>
                        <Button className="float-right" onClick={() => props.onRemoveContacts(props.ids)} color="danger" outline>삭제</Button>
                    </Col>
                </Row>
            </Container>
            <Container>
                <ContactPagination
                    contacts={props.contacts}
                />
            </Container>
        </div>
        );
}

const mapStateToProps = (state) => {
    return {
        contacts : state.admin.contact.contacts,
        ids: state.admin.contact.ids
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onRemoveContacts : (ids) => {
            dispatch(contactActions.removeContacts(ids));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(contactManager);


// WEBPACK FOOTER //
// ./src/pages/Admin/ContactManager/ContactManager.js